import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Rocket, X, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";

// Compact activation nudge (cc_12): deep-links into the Help Center's Getting Started checklist.
export function GettingStartedNudge() {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);
  const { data } = useQuery({ queryKey: ["help-checklist"], queryFn: api.helpChecklist, staleTime: 30000 });
  if (dismissed || !data) return null;

  const tasks = data.tasks || [];
  const done = data.done ?? tasks.filter((t) => t.done).length;
  const total = data.total ?? tasks.length;
  const remaining = total - done;
  if (!total || remaining <= 0) return null;
  const next = tasks.find((t) => !t.done);

  return (
    <div
      className="mx-5 mb-2 flex items-center gap-2.5 rounded-2xl border border-bloq-mint/25 bg-bloq-mint/[0.08] px-3 py-2"
      data-testid="getting-started-nudge"
    >
      <button
        onClick={() => navigate("/app/help")}
        className="flex min-w-0 flex-1 items-center gap-2.5 text-left"
        data-testid="getting-started-nudge-open"
      >
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-bloq-mint/20 text-bloq-mint">
          <Rocket className="h-4 w-4" />
        </span>
        <div className="min-w-0 flex-1">
          <div className="text-xs font-bold text-white">
            {remaining === 1 ? "1 step left to get started" : `${remaining} steps left to get started`}
          </div>
          {next && <div className="truncate text-[11px] text-bloq-mint">Next: {next.title}</div>}
        </div>
        <ChevronRight className="h-4 w-4 shrink-0 text-bloq-mint/70" />
      </button>
      <button
        onClick={() => setDismissed(true)}
        className="shrink-0 text-bloq-muted transition-colors hover:text-white"
        data-testid="getting-started-nudge-dismiss"
        aria-label="Dismiss"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
